import React from 'react';

/**
 * PaymentModal — EMI payment record karna.
 * Sabhi state Inventory.js mein hai; ye component sirf UI hai.
 *
 * Props:
 *   show              — boolean
 *   emiPlans          — array (selectedEmi dhundhne ke liye)
 *   selectedEmiId     — string | null
 *   paymentAmount     — string
 *   paymentLoading    — boolean
 *   calculateLateFee  — (emiPlan) => number
 *   onAmountChange(v) — setPaymentAmount
 *   onSubmit()        — submitPayment
 *   onClose()         — setShowPaymentModal(false)
 */
export default function PaymentModal({
  show,
  emiPlans,
  selectedEmiId,
  paymentAmount,
  paymentLoading,
  calculateLateFee,
  onAmountChange,
  onSubmit,
  onClose
}) {
  if (!show) return null;

  const selectedEmi = emiPlans.find((emi) => emi._id === selectedEmiId);

  const pendingAmount = selectedEmi
    ? selectedEmi.emiPlan.totalAmount -
      selectedEmi.payments.reduce((sum, p) => (p.status === 'completed' ? sum + p.amount : sum), 0)
    : 0;
  const lateFee = selectedEmi ? calculateLateFee(selectedEmi) : 0;
  const monthlyAmount = selectedEmi ? selectedEmi.emiPlan.monthlyAmount : 0;

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Record EMI Payment</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            {selectedEmi && (
              <div className="mb-3">
                <div className="alert alert-info">
                  <div className="row">
                    <div className="col-6">
                      <strong>Customer:</strong> {selectedEmi.customer.name}
                    </div>
                    <div className="col-6">
                      <strong>Product:</strong> {selectedEmi.productInfo?.name}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      <strong>Monthly EMI:</strong> ₹{Number(monthlyAmount).toFixed(0)}
                    </div>
                    <div className="col-6">
                      <strong>Pending:</strong> ₹{pendingAmount.toLocaleString()}
                    </div>
                  </div>
                  {lateFee > 0 && (
                    <div className="row mt-2">
                      <div className="col-12">
                        <strong className="text-danger">Late Fee:</strong> ₹{lateFee.toLocaleString()}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="form-group mb-3">
              <label htmlFor="payment-amount" className="form-label">
                Payment Amount
              </label>
              <div className="input-group">
                <span className="input-group-text">₹</span>
                <input
                  type="number"
                  className="form-control"
                  id="payment-amount"
                  placeholder="Enter amount"
                  value={paymentAmount}
                  onChange={(e) => onAmountChange(e.target.value)}
                />
              </div>
            </div>

            <div className="d-flex gap-2 mb-3">
              <button
                type="button"
                className="btn btn-outline-secondary flex-grow-1"
                onClick={() => selectedEmi && onAmountChange(Number(monthlyAmount).toFixed(0))}
              >
                Set Monthly Amount
              </button>
              <button
                type="button"
                className="btn btn-outline-danger flex-grow-1"
                onClick={() => selectedEmi && onAmountChange(lateFee.toFixed(0))}
              >
                Set Late Fee
              </button>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSubmit}
              disabled={paymentLoading}
            >
              {paymentLoading ? 'Processing...' : 'Submit Payment'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
